import { getPlayedGamesPeriods, getUnplayableGamesPeriods } from "../../../../../../sports/rules.js";
import { getPlayer, getTeam } from "../../utils.js";
import GameFactEventDto from "../GameFactEventDto.js";

let allUnplayablePeriods = getPlayedGamesPeriods("handball");

export class StopDto extends GameFactEventDto {

    constructor(event){
        super(event);
        this.tab = event.tab ??"FIN"
        this.detail = {
            ...this.detail,
            title : event.detail?.title || "FIN",
            comment : event.detail?.comment,
          };
    }

    get comment() {
        return this.detail.comment;
      }

    set comment(value) {
        this.detail.comment = value;
    }

    initTimerPeriod(match){
        super.initTimerPeriod(match)

        this.detail.title = ("FIN "+ allUnplayablePeriods.get(this.detail.period).name).toUpperCase()
    }

    updateDetail(key, value, match) {
        super.updateDetail(key, value)

        if(this.isAutomaticCommentary && ["isAutomaticCommentary", "reason"].includes(key)){

            if("end" === this.reason)
                this.comment = 'Le match est terminé !'
            else if("tab" === this.reason)
                this.comment = 'Direction les tirs au but !'
            else if("next" === this.reason)
                this.comment = 'Mi-temps avant le début de la prochaine période !'
        }
    }
}